export const connectWalletModalType = "connectWallet";
